<div class="modal-content modal-milvus" style="zoom: 0.85;">
    <ngx-spinner></ngx-spinner>
    <div class="modal-header-milvus align-items-center dark-back">
        <div class="col-6 header-col" style="margin-top: -10px; margin-left: -6px;">
            <span class="modal-title" id="modal-title-default">{{'MENSAGENS' | translate}}</span>
        </div>
        <div class="col-6 header-col" style="margin-top: -10px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body divider-top px-0" style="overflow: hidden; padding: 0 !important;">
        <div class="row w-100 ml-0">
            <div class="col-12 dark-back">
                <!-- informacoes do chat -->
                <div class="row line-data" style="margin-bottom: 10px; margin-top: 10px !important;">
                    <div *ngIf="chatSelecionado" class="d-flex col-12 mt-2">
                        <ng-container *ngIf="!chatSelecionado.is_chat_email; else cabecalhoChatEmail">
                            <div>
                                <img alt="Image placeholder"
                                    [src]="chatSelecionado.avatar || 'assets/img/theme/user.png'"
                                    class="avatar rounded-circle mt-1 mr-3" style="max-width: 49px;"
                                    (click)="abrirInfoContato(chatSelecionado)" />
                            </div>
                            <div>
                                <div class="chat-name">
                                    {{chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao :
                                    chatSelecionado.numero_contato ? chatSelecionado.numero_contato : ''}}
                                    {{chatSelecionado.cliente && chatSelecionado.cliente.text ? '- ' +
                                    chatSelecionado.cliente.text : null }}
                                </div>
                                <div class="chat-name">
                                    {{chatSelecionado.contato?.celular ?
                                    (chatSelecionado.contato?.celular | mask:'(00) 00000-0000 || (00) 0000-0000') :
                                    chatSelecionado.contato?.telefone
                                    ? (chatSelecionado.contato?.telefone | mask:'(00) 0000-0000') : ''}}
                                    {{chatSelecionado.contato?.email ? '- ' + chatSelecionado.contato?.email :
                                    chatSelecionado.email ?
                                    '- ' + chatSelecionado.email : ''}}
                                </div>
                                <div class="chat-lastmsg" style="cursor: pointer;"
                                    *ngIf="chatSelecionado.chamado_vinculado"
                                    (click)="openTicket(chatSelecionado.chamado_vinculado)">
                                    <i style="margin-top: 5px;" *ngIf="chatSelecionado.chamado_vinculado"
                                        class="fas fa-ticket-alt fa-lg"></i>
                                    {{ chatSelecionado.chamado_vinculado ? ' #'+chatSelecionado.chamado_vinculado.codigo
                                    :
                                    ''}}
                                </div>
                                <div class="chat-lastmsg">
                                    {{ 'ULTIMA_INTERACAO' | translate }} {{chatSelecionado.data_mensagem}}
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #cabecalhoChatEmail>
                            <div class="d-flex">
                                <div>
                                    <img alt="Image placeholder"
                                        [src]="chatSelecionado.avatar || 'assets/img/theme/user.png'"
                                        class="avatar rounded-circle mt-1 mr-3" style="max-width: 49px;"
                                        (click)="abrirInfoContato(chatSelecionado)" />
                                </div>
                                <div>
                                    <div class="chat-name d-flex">
                                        {{chatSelecionado.chat_email_ui?.cabecalho_nome_remetente ?
                                        chatSelecionado.chat_email_ui?.cabecalho_nome_remetente : ''}}
                                        {{chatSelecionado.cliente && chatSelecionado.cliente.text ? '- ' +
                                        chatSelecionado.cliente.text : null }}
                                        <span *ngIf="chatSelecionado.chat_email_ui?.cc_quantidade"
                                            [ngbTooltip]="templateChatEmailCabecalhoCC" position="bottom"
                                            container="'.modal'" tooltipClass="tooltip-custom" class="ver-mais-chat-email-cc">
                                            {{'E_MAIS' | translate}}{{' ' +
                                            chatSelecionado.chat_email_ui?.cc_quantidade}}
                                        </span>
                                        <ng-template #templateChatEmailCabecalhoCC>
                                            <div *ngFor="let cc of chatSelecionado.chat_email_ui?.cc_detalhes">
                                                <span>{{cc.address}}</span>
                                                <br>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="chat-name">
                                        <ng-container *ngIf="chatSelecionado.protocolo">
                                            <b>{{ 'PROTOCOLO' | translate }}: {{ chatSelecionado.protocolo }}</b>
                                        </ng-container>
                                        <ng-container *ngIf="chatSelecionado.chat_email_ui?.cabecalho_email_remetente">
                                            {{' - ' + chatSelecionado.chat_email_ui?.cabecalho_email_remetente}}
                                        </ng-container>
                                    </div>
                                    <div class="chat-name" *ngIf="chatSelecionado.chat_email_ui?.assunto_email"
                                        [title]="chatSelecionado.chat_email_ui?.assunto_email">
                                        {{'ASSUNTO' | translate}}:{{' ' + chatSelecionado.chat_email_ui?.assunto_email |
                                        ellipsis: 70}}
                                    </div>
                                    <div class="chat-lastmsg" style="cursor: pointer;"
                                        *ngIf="chatSelecionado.chamado_vinculado"
                                        (click)="openTicket(chatSelecionado.chamado_vinculado)">
                                        <i style="margin-top: 5px;" *ngIf="chatSelecionado.chamado_vinculado"
                                            class="fas fa-ticket-alt fa-lg"></i>
                                        {{ chatSelecionado.chamado_vinculado ? '
                                        #'+chatSelecionado.chamado_vinculado.codigo
                                        :
                                        ''}}
                                    </div>
                                    <div class="chat-lastmsg">
                                        {{ 'ULTIMA_INTERACAO' | translate }} {{chatSelecionado.data_mensagem}}
                                    </div>
                                    <div *ngIf="chatSelecionado && chatSelecionado?.transferencia_msg_title"
                                        [ngbTooltip]="chatSelecionado?.transferencia_msg_title?.length > 50 ? chatSelecionado?.transferencia_msg_title : ''"
                                        class="chat-lastmsg" style="color: #004eff;">
                                        {{chatSelecionado?.transferencia_msg_title}}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row dark-back w-100 ml-0" style="height: 600px;">
            <div class="col-12 darker-back divider-top p-0" style="height: 100%;">
                <div id="chat-msgs">
                    <div #scrollMe id="msg-item" class="msg-item" style="bottom: 59px;" (scroll)="onScroll($event)">
                        <div *ngIf="mais_registros; else semMaisConversas"
                            class="w-100 d-flex justify-content-center m-3">
                            <button type="button" class="btn-carregar-mais-conversas" (click)="carregarMaisConversas()">
                                <i class="fa-regular fa-arrow-up mr-3"></i>
                                <span [translate]="'VER_CONVERSAS_ANTERIORES'"></span>
                            </button>
                        </div>
                        <ng-template #semMaisConversas>
                            <div *ngIf="!mais_registros && pagina > 1" class="w-100 d-flex justify-content-center m-3">
                                <div class="btn-sem-mais-conversas">
                                    <i class="fa-sharp fa-regular fa-xmark font-20 mr-3"></i>
                                    <span [translate]="'SEM_CONVERSAS_ANTERIORES'"></span>
                                </div>
                            </div>
                        </ng-template>
                        <div #messages class="msg" *ngFor="let chat of mensagensChat">
                            <div *ngIf="mais_registros || pagina > 1" class="w-100 d-flex justify-content-center m-3">
                                <div class="d-flex btn-conversa-anterior">
                                    <i class="fa-solid fa-clock-rotate-left mr-3"></i>
                                    <span [translate]="'CONVERSA_ANTERIOR'"></span>
                                    <span>-</span>
                                    <span>{{chat.data_chat | date:'dd/MM/YYYY'}}</span>
                                    <span>-</span>
                                    <span>{{chat.data_chat | date:'HH:mm:ss'}}</span>
                                </div>
                            </div>
                            <ng-container *ngFor="let msg of chat.listaMensagens; let i = index; let last = last">
                                <!-- Separação de anexos com legenda -->
                                <ng-container
                                    *ngIf="msg.tipo === 'anexo' && msg.msg_legenda && !msg.resposta_enviado_por; else msgComum">
                                    <div [id]="'msg-'+i"
                                        [ngbTooltip]="msg.formatedBody.length > 50 ? msg.formatedBody : ''"
                                        (click)="visualizarArquivo(msg, $event)" class="msg-destino text-left"
                                        style="white-space: pre-line; word-break: break-word;">
                                        <div class="msg-anexo-com-legenda" [innerHtml]="msg?.formatedBody"></div>
                                        <div class="mt-2" [innerHTML]="msg?.msg_legenda"></div>
                                        <div class="text-right msg-time">
                                            {{msg?.data_mensagem | date:'dd/MM/YYYY HH:mm:ss':'UTC'}}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #msgComum>
                                    <ng-container *ngIf="msg.is_mensagem_email; else otherChatTypeMsgs">
                                        <div [id]="'msg-'+i"
                                            [ngClass]="msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' ? 'text-right' : 'text-left'">
                                            <div class="msg-origem"
                                                *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody && !msg.error_code && !msg.is_tranferencia">
                                                <div class="email-cabecalho-mensagem-chat d-grid justify-content-end" *ngIf="msg.email_cabecalho">
                                                    <b>{{msg.autor?.nome}}{{' - <' + msg.email_cabecalho.remetente_caixa + '>' }}</b>
                                                    <div *ngIf="msg.email_cabecalho.destinatarios_envio && msg.email_cabecalho.destinatarios_envio.length">
                                                        <span>{{'PARA' | translate}}:</span>
                                                        <span class="destinatarios-chat-email">{{ msg.email_cabecalho.destinatarios_envio | concatByComma }}</span>
                                                    </div>
                                                    <div *ngIf="msg.email_cabecalho.cc_envio && msg.email_cabecalho.cc_envio.length">
                                                        <span>cc:</span>
                                                        <span class="destinatarios-chat-email">{{ msg.email_cabecalho.cc_envio | concatByComma }}</span>
                                                    </div>
                                                    <hr class="email-cabecalho-separador mb-2 mt-2" />
                                                </div>
                                                <div [innerHtml]="msg.body_format === 'html' ? msg.email_html_corpo : msg.formatedBody"
                                                    (click)="visualizarArquivo(msg, $event)" class="text-left corpo-chat-email"
                                                    style="white-space: normal; word-break: break-word;">
                                                </div>
                                                <div class="anexos-chat-email"
                                                    *ngIf="msg.anexos_email && msg.anexos_email.length">
                                                    <span class="justify-content-start" style="font-weight: bold; font-size: 14px;"
                                                        [translate]="'ARQUIVOS_ANEXADOS'"></span>
                                                    <div class="anexo-chat-email card" *ngFor="let file of msg.anexos_email"
                                                        (click)="abrirArquivo(file.url)">
                                                        <i class="fa-duotone fa-regular fa-paperclip"></i>
                                                        {{file.nome}} ({{porcentagemArquivo(file.tamanho_bytes)}} MB)
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="msg-destino"
                                                *ngIf="msg.enviado_por === 'cliente' && msg.formatedBody">
                                                <div class="email-cabecalho-mensagem-chat" *ngIf="msg.email_cabecalho">
                                                    <b>{{msg.email_cabecalho.remetente?.name}}
                                                        <{{msg.email_cabecalho.remetente?.address}}>
                                                    </b>
                                                    <div *ngIf="msg.email_cabecalho.para && msg.email_cabecalho.para.length">
                                                        <span>{{'PARA' | translate}}:</span>
                                                        <span class="destinatarios-chat-email">{{ msg.email_cabecalho.para | concatByComma: 'address' }}</span>
                                                    </div>
                                                    <div *ngIf="msg.email_cabecalho.cc && msg.email_cabecalho.cc.length">
                                                        <span>cc:</span>
                                                        <span class="destinatarios-chat-email">{{ msg.email_cabecalho.cc | concatByComma: 'address' }}</span>
                                                    </div>
                                                    <hr class="email-cabecalho-separador mb-2 mt-2" />
                                                </div>
                                                <div [innerHtml]="msg.body_format === 'html' ? msg.email_html_corpo : msg.formatedBody"
                                                    (click)="visualizarArquivo(msg, $event)" class="text-left corpo-chat-email"
                                                    style="white-space: normal; word-break: break-word;">
                                                </div>
                                                <div class="anexos-chat-email"
                                                    *ngIf="msg.anexos_email && msg.anexos_email.length">
                                                    <span class="justify-content-start" style="font-weight: bold; font-size: 14px;"
                                                        [translate]="'ARQUIVOS_ANEXADOS'"></span>
                                                    <div class="anexo-chat-email card" *ngFor="let file of msg.anexos_email"
                                                        (click)="abrirArquivo(file.url)">
                                                        <i class="fa-duotone fa-regular fa-paperclip"></i>
                                                        {{file.nome}} ({{porcentagemArquivo(file.tamanho_bytes)}} MB)
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #otherChatTypeMsgs>
                                        <div [id]="'msg-'+i"
                                            [ngClass]="msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' ? 'text-right' : 'text-left'">
                                            <div container=".modal"
                                                [ngbTooltip]="msg.formatedBody.length > 50 ? msg.formatedBody : ''"
                                                [innerHtml]="msg.formatedBody" (click)="visualizarArquivo(msg, $event)"
                                                class="msg-origem msg-transferencia text-left"
                                                *ngIf="msg.is_transferencia && msg.formatedBody"
                                                style="white-space: pre-line; word-break: break-word;">
                                            </div>
                                            <div container=".modal" [ngbTooltip]="msg.autor ? msg.autor.nome : msg.user"
                                                [innerHtml]="msg.formatedBody" (click)="visualizarArquivo(msg, $event)"
                                                class="msg-origem text-left"
                                                *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody"
                                                style="white-space: pre-line; word-break: break-word;">
                                            </div>
                                            <div container=".modal"
                                                [ngbTooltip]="chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao : 
                                            chatSelecionado.numero_contato ? chatSelecionado.numero_contato : msg.autor ? msg.autor.nome : msg.user"
                                                [innerHtml]="msg.formatedBody" class="msg-destino text-left"
                                                style="white-space: pre-line; word-break: break-word;"
                                                *ngIf="msg.enviado_por === 'cliente' && msg.formatedBody">
                                            </div>
                                        </div>
                                    </ng-template>
                                </ng-template>
                                {{last ? scrollToBottom() : ''}}
                            </ng-container>
                        </div>
                    </div>
                    <div class="darker-back input-box">
                        <div class="row" style="padding: 14px;">
                            <div class="col-12 justify-content-center">
                                <span>
                                    {{ ('HISTORICO_CONVERSAS' | translate)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button *ngIf="verificaMostraScrollBtn()" type="button"
            class="btn btn-sm small-circled-btn btn-chat-scroll-bottom" (click)="goToBottom()"
            [ngbTooltip]="'DESCER_FIM' | translate" container=".modal" placement="top-right"
            tooltipClass="tooltip-btn-scroll-chat">
            <i class="fa-sharp fa-solid fa-chevron-down"></i>
        </button>
    </div>
</div>